import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import { ToastContext } from '../../../../context/ToastContext';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SalesStatusDetails = () => {
  const { statusId } = useParams();
  const decodedId = statusId ? atob(statusId) : statusId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES.salesStatus}${id}/` : null;
  const { data: status, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!status) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(status)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [status]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.salesStatus}${id}/`);
      showToast('Sales Status deleted successfully', 'success');
      navigate('/customer/sales-status/list');
    } catch (error) {
      console.error('Error deleting sales status:', error);
      showToast('Failed to delete sales status', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={status}
        columns={columns}
        loading={loading}
        entityName="Sales Status"
        listPath="/customer/sales-status/list"
        editPath={`/customer/sales-status/input/${btoa(statusId)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        title="Delete Sales Status"
        message="Are you sure you want to delete this sales status? This action cannot be undone."
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SalesStatusDetails;
